// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     if ("scrollRestoration" in window.history) {
//       window.history.scrollRestoration = "manual";
//     }

//     setTimeout(() => {
//       window.scrollTo(0, 0);
//     }, 100);
//   }, [pathname]);

//   return null;
// };

// export default ScrollToTop;
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      // window (fallback)
      window.scrollTo(0, 0);

      // html/body (mobile fix)
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // REAL scroll containers
      const appMain = document.querySelector(".app-main");
      if (appMain) {
        appMain.scrollTop = 0;
      }

      const left = document.querySelector(".left");
      if (left) {
        left.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;

